export default {
  IsoDuration: {
    maxDurationError: '[en] Ошибка валидации. Максимальное значение таймера - {{}}',
  },
  viewClientPagesButton: {
    seeAsClient: "See client's cabinet",
    backToProfile: 'Back to Profile',
  },
  neverViewButton: {
    label: "Don't show again",
    cancelButton: 'Keep visible',
    submitButton: 'Hide',
  },
};
